// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"DP-z","inlineTitle":"EP-z","sponsoredAdsWrapper":"FP-z","marketplaceRecosWrapper":"GP-z"};